import { orderBy } from "lodash";
import { Api } from "queries/types";
import { State } from "./types";

interface BuildSectionsParams {
  shelvesCount?: number;
  cell?: Api.ShopGridCell;
  families?: Api.Family[];
}

const buildSections = ({ shelvesCount, cell, families }: BuildSectionsParams) => {
  const sections = orderBy(cell?.shopGridCellSections || [], "sectionIndex");
  return [...Array(shelvesCount || 1)].map((_, sectionIndex) => {
    const section = sections[sectionIndex];

    const inventories = orderBy(section?.shopGridCellSectionInventories || [], "inventoryIndex");
    return {
      id: section?.id,
      inventories: [...Array(section?.shopGridCellSectionInventories.length || 1)].map((_, inventoryIndex) => {
        const inventory = inventories[inventoryIndex];

        return {
          id: inventory?.id,
          quantity: inventory?.quantity || 100,
          family: inventory?.subFamily?.familyId
            ? (families || []).find((family) => family.id === inventory.subFamily.familyId) || null
            : null,
          subFamily: inventory?.subFamily || null,
        };
      }),
    };
  });
};

const to2dArray = (cells: Api.ShopGridCell[]) => {
  const lines = [] as Api.ShopGridCell[][];
  cells.forEach((cell) => {
    lines[cell.yAxis] = lines[cell.yAxis] || [];
    lines[cell.yAxis][cell.xAxis] = cell;
  });
  return lines;
};

const buildGridState = (activeGrid: Api.ShopGrid, gridProposal?: Api.ShopGrid, families?: Api.Family[]): State.Grid => {
  const activeCells = to2dArray(activeGrid.shopGridCells);
  const proposalCells = to2dArray(gridProposal?.shopGridCells || []);
  const proposalExist = !!gridProposal;

  const lines = [...Array(activeGrid.height)].map((_, yAxis) =>
    [...Array(activeGrid.width)].map((_, xAxis) => {
      const activeCell = activeCells[yAxis]?.[xAxis];
      const proposalCell = proposalCells[yAxis]?.[xAxis];
      const activeSections = buildSections({ shelvesCount: activeCell?.shelvesCount, cell: activeCell, families });
      const proposalSections = buildSections({ shelvesCount: activeCell?.shelvesCount, cell: proposalCell, families });

      return {
        id: proposalExist ? proposalCell?.id : activeCell?.id,
        furniture: activeCell?.shopFurniture || null,
        isHighlight: activeCell?.isHighlight || false,
        shelvesCount: activeCell?.shelvesCount || 1,
        yAxis,
        xAxis,
        sections: gridProposal ? proposalSections : activeSections,
        originalSections: gridProposal ? activeSections : null,
      };
    })
  );

  return { lines, height: activeGrid.height!, width: activeGrid.width! };
};

export default buildGridState;
export { buildSections };
